import moment from "moment";
import numeral from "numeral";
import React from "react";
import "./style.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { isNumeric } from "../../../libs/utils";

const DetailSummary = ({ activityTotals, currentSettlement, monthNumber, selectedYear }) => {
  const intl = useIntl();
  const currentMonth = isNumeric(monthNumber) ? moment().month(monthNumber -1, "M").format("MMMM") : intl.formatMessage({ id: `reports.vat.${monthNumber}`});
  
  return (
    <div style={{paddingBottom: 40}}>
      <div className="title" style={{ textTransform: "capitalize" }}>
        {`${currentMonth} ${selectedYear || ""}`}
      </div>
      <div className="title" style={{ fontSize: 20 }}>
        <FormattedMessage id="reports.vat.activityDetail.activitySummary"/>
        {`: ${currentSettlement?.businessDescription || ""}`}
      </div>
      { !!currentSettlement?.previousDebt && 
      <div className="settlementDetailLine"> 
        <div className="lineDescription">
          <FormattedMessage id="reports.vat.activityDetail.previousDebt"/>
        </div>
        <div className="lineAmount">
          {numeral(Math.abs(currentSettlement?.previousDebt)).format("0,0.00")} €
        </div>
      </div>
      }
      {!!currentSettlement?.vatDeposit &&
        <div className="settlementDetailLine">
          <div className="lineDescription">
            <FormattedMessage id="reports.vat.activityDetail.vatDeposit"/>
          </div>
          <div className="lineAmount">
            {numeral(Math.abs(currentSettlement?.vatDeposit)).format("0,0.00")} €
          </div>
        </div>
      }
      {activityTotals?.map((el, index) => (
        <>
          <div key={"activity_total_"+index} className="settlementDetailLine">
            <div className="lineDescription">
              <FormattedMessage id="reports.vat.activityDetail.vatOn"/> {<FormattedMessage id={`reports.vat.${el.description?.toUpperCase()}`} />}
            </div>
            <div className="lineAmount">
              {numeral(Math.abs(el.taxTotal)).format("0,0.00")} €
            </div>
          </div>
          {(el.description === "purchase" && el.nonDeductibleTotal) ? <div key={"activity_total_"+index} className="settlementDetailLine">
            <div className="lineDescription">
              <FormattedMessage id="reports.vat.activityDetail.vatOn"/> {<FormattedMessage id={"reports.vat.PURCHASE_NON_DETRAIBILE"} />}
            </div>
            <div className="lineAmount">
              {numeral(Math.abs(el.nonDeductibleTotal)).format("0,0.00")} €
            </div>
          </div> : null}
        </>
      ))}
      {!!currentSettlement?.payableTax &&
        <div className="settlementDetailLine">
          <div className="lineDescription">
            <FormattedMessage id="reports.vat.multiActivity.amountOnDebit"/>
          </div>
          <div className="lineAmount">
            {numeral(Math.abs(currentSettlement?.payableTax)).format("0,0.00")} €
          </div>
        </div>
      }
      {!!currentSettlement?.reportedDebt &&
        <div className="settlementDetailLine">
          <div className="lineDescription">
            <FormattedMessage id="reports.vat.activityDetail.reportedDebt"/>
          </div>
          <div className="lineAmount">
            {numeral(Math.abs(currentSettlement?.reportedDebt)).format("0,0.00")} €
          </div>
        </div>
      }
    </div>
  );
};
export default DetailSummary;
